import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {AcceptingPageVO, useQueryAcceptingPage} from "@/service/accepting.s";
import {useAuthInfo} from "@/store/account.c";
import Chip from "@mui/material/Chip";
import {assign} from "lodash";
import {ViewAccepting} from "@/pages/Accepting/ViewAccepting";
import {WriteAccepting} from "@/pages/Accepting/WriteAccepting";
import {AuthButtonVO} from "@/service/menu.s";
import {TaskReview} from "@/widget/TaskReview/TaskReview";

export const AcceptingListPage = () => {
    const {
        mutate: acceptingPageMutate,
        data: acceptingPageData,
        isPending: acceptingPagePending,
    } = useQueryAcceptingPage()
    const {id: authId} = useAuthInfo()

    const columns: GridColDef<AcceptingPageVO>[] = [
        {
            field: "planName",
            headerName: "目标计划",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {field: "taskName", headerName: "任务名称", flex: 0.6},
        {
            field: "virtue",
            headerName: "任务属性",
            headerAlign: "center",
            align: "center",
            renderCell: ({row: {virtue, virtueId}}) => {
                let style = {}
                if (virtueId == 1) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#eb5050 !important', border: 'none'};
                } else if (virtueId == 2) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#f0a800 !important', border: 'none'};
                }
                return <Chip label={virtue} variant={'filled'} size={'small'} sx={style}/>
            }
        },
        {
            field: "description",
            headerName: "验收说明",
            flex: 0.6,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: value => `${value}小时`
        },
        {
            field: "creator",
            headerName: "创建人",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "left",
            align: "left",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "priority",
            headerName: "优先级",
            headerAlign: "center",
            flex: 0.5,
            align: "center",
            renderCell: ({row: {priority, priorityId}}) => {
                let style = {}
                if (priorityId == 1) {
                    style = {backgroundColor: '#fa5353 !important', border: 'none'};
                } else if (priorityId == 2) {
                    style = {backgroundColor: '#ff9d8d !important', border: 'none'};
                } else if (priorityId == 3) {
                    style = {backgroundColor: '#f5c13c !important', border: 'none'};
                } else if (priorityId == 4) {
                    style = {backgroundColor: '#3f8cff !important', border: 'none'};
                } else if (priorityId == 5) {
                    style = {backgroundColor: '#2fcd6e !important', border: 'none'};
                }
                return <Chip label={priority} variant={'filled'} size={'small'} sx={assign(style, {"& .MuiChip-label": {color: '#fff'}})}/>
            }
        },
        {
            field: "executor",
            headerName: "负责人",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            renderCell: ({row: {status}}) => {
                let style = {}
                let text = "待审核"
                if (status == -1) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#eb5050 !important', border: 'none'};
                    text = "未通过"
                } else if (status == 1) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#f0a800 !important', border: 'none'};
                    text = "已通过"
                }
                return <Chip label={text} variant={'filled'} size={'small'} sx={style}/>
            }
        },
    ];

    return (
        <ProTable<AcceptingPageVO>
            loading={acceptingPagePending}
            verifyBtns={(row: AcceptingPageVO, btns: AuthButtonVO[]) => {
                return btns.map((btn) => {
                    if (btn.alias == 'audit') {
                        return {...btn, disabled: row.executorId !== authId || row.status != 0, maxWidth: 'xs', body: <TaskReview tag={3}/>}
                    }
                    return btn
                })
            }}
            renderDrawer={{view: <ViewAccepting/>, write: <WriteAccepting mode={'drawer'}/>}}
            columns={columns}
            data={acceptingPageData?.data}
            onSearch={(params) => {
                acceptingPageMutate(params);
            }}
            code={"accepting"}
        />
    );
};
